<template>
  <div class="w-100">
    <h-f-fields
      v-model="selectedArray"
      input-type="multi-select"
      :multi-select="choices"
      :reduce="false"
      @searchchange="searchChoices"
    ></h-f-fields>
  </div>
</template>

<script>
import { APIRequest } from '@/node-sdk'

export default {
  name: 'multi-filter',

  props: {
    value: String,
    ressource: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
    optionValue: {
      type: String,
      default: 'id',
    },
    optionText: {
      type: Array,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      choices: [],
      selected: this.value,
      selectedArray: [],
    }
  },

  watch: {
    selectedArray() {
      const selected = []
      this.selectedArray.forEach((selectedI) => {
        selected.push(selectedI.value)
      })
      this.selected = selected.join()
    },

    selected: {
      deep: true,
      handler() {
        this.$emit('input', this.selected)
      },
    },

    value() {
      this.selected = this.value
      if (!this.isEqual()) {
        this.formatSelectedArray()
      }
    },
  },

  async mounted() {
    await this.searchChoices('')
  },

  methods: {
    async searchChoices(input) {
      const [choices] = await APIRequest.get_with_request(this.ressource, this.route, `?search=${input}`)
      this.choices = []
      choices.forEach((choice) => {
        let text = ''
        for (let i = 0; i < this.optionText.length; i++) {
          text += `${choice[this.optionText[i]]} `
        }
        this.choices.push({
          value: choice[this.optionValue],
          text,
        })
      })
    },

    async formatSelectedArray() {
      if (this.selected) {
        this.selectedArray = []
        const [entities] = await APIRequest.get_with_request(
          this.ressource,
          this.route,
          `?${this.entity}__in=${this.selected}`,
        )
        entities.forEach((entity) => {
          let text = ''
          for (let i = 0; i < this.optionText.length; i++) {
            text += `${entity[this.optionText[i]]} `
          }
          this.selectedArray.push({
            value: entity[this.optionValue],
            text,
          })
        })
      }
    },

    isEqual() {
      const selectedArrayTest = this.selected.split(',')
      if (selectedArrayTest.length !== this.selectedArray.length) {
        return false
      }
      for (let i = 0; i < this.selectedArray.length; i++) {
        if (this.selectedArray[i].value !== selectedArrayTest[i]) {
          return false
        }
      }

      return true
    },
  },
}
</script>

<style scoped></style>
